let sub_domain = window.location.href.split("//")[1].split(".")[0];
let url = `https://${sub_domain}.user.hisaav.com`;

if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
    url = `http://${sub_domain}.lvh.me:8001`;
}

export const domain = url;

